import React, { useState, useEffect } from 'react';
import { db } from '../firebase';
import { doc, updateDoc, arrayUnion } from "firebase/firestore";
import defaultBanner from '../assets/barbershop.jpeg';
import { translations } from './Translation';

function Hero({ shop, user }) {
  const [reviewText, setReviewText] = useState('');
  const [reviewRating, setReviewRating] = useState(5);
  const [language, setLanguage] = useState(localStorage.getItem('elitecut_lang') || 'en');
  const t = translations[language] || translations.en;

  useEffect(() => {
    const handleStorage = () => setLanguage(localStorage.getItem('elitecut_lang') || 'en');
    window.addEventListener('storage', handleStorage);
    return () => window.removeEventListener('storage', handleStorage);
  }, []);

  if (!shop) return null;

  const handleReviewSubmit = async () => {
    if (!user) return alert("You must be logged in to leave a review.");
    if (!reviewText) return;

    const currentCount = shop.reviewCount || 0;
    const currentAvg = shop.rating || 5;
    const newAvg = ((currentAvg * currentCount) + reviewRating) / (currentCount + 1);

    try {
      const shopRef = doc(db, "shops", shop.id);
      await updateDoc(shopRef, {
        reviews: arrayUnion({
          userName: user.name,
          text: reviewText,
          rating: reviewRating,
          date: new Date().toISOString()
        }),
        reviewCount: currentCount + 1,
        rating: Number(newAvg.toFixed(1))
      });
      alert("Review submitted!");
      setReviewText('');
      setReviewRating(5);
    } catch (error) {
      alert("Error submitting review: " + error.message);
    }
  };

  return (
    <div className="hero-section" style={{ backgroundImage: `url(${shop.shopImage || defaultBanner})`, backgroundSize: 'cover', backgroundPosition: 'center', borderRadius: '24px', overflow: 'hidden', marginTop: '20px' }}>
      <div className="hero-overlay" style={{ background: 'linear-gradient(to top, rgba(15,23,42,0.9), transparent)', height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'flex-end', padding: '40px' }}>
        
        <h1 style={{ color: 'white', fontSize: '48px', margin: '0 0 10px 0' }}>{shop.shopName}</h1>
        <p style={{ color: '#cbd5e1', fontSize: '18px', margin: '0 0 20px 0' }}>📍 {shop.address || shop.location || t.locationTBD}</p>
        
        <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
          <span style={{ background: '#10b981', color: 'white', padding: '5px 10px', borderRadius: '8px', fontWeight: 'bold' }}>
            {shop.rating || '5.0'} ⭐
          </span>
          <span style={{ color: 'white' }}>({shop.reviewCount || 0} {t.reviews})</span>
        </div>

        {user?.role === 'Client' && (
          <div style={{ marginTop: '30px', display: 'flex', flexDirection: 'column', gap: '10px', maxWidth: '500px', background: 'rgba(255,255,255,0.1)', padding: '15px', borderRadius: '12px', backdropFilter: 'blur(5px)' }}>
            
            <div style={{ display: 'flex', gap: '5px' }}>
              <span style={{ color: 'white', marginRight: '10px', alignSelf: 'center', fontSize: '14px' }}>{t.rateExp}</span>
              {[1, 2, 3, 4, 5].map(star => (
                <span key={star} onClick={() => setReviewRating(star)} style={{ cursor: 'pointer', fontSize: '24px', transition: '0.2s', color: star <= reviewRating ? '#fbbf24' : '#94a3b8' }}>★</span>
              ))}
            </div>

            <div style={{ display: 'flex', gap: '10px' }}>
              <input type="text" placeholder={t.writeRev} value={reviewText} onChange={(e) => setReviewText(e.target.value)} style={{ flex: 1, padding: '12px', borderRadius: '8px', border: 'none', outline: 'none' }} />
              <button onClick={handleReviewSubmit} style={{ background: '#3b82f6', color: 'white', border: 'none', padding: '0 20px', borderRadius: '8px', cursor: 'pointer', fontWeight: 'bold' }}>
                {t.submit}
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default Hero;